import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown } from 'react-bootstrap';

const LanguageSelector = ({ variant = 'light', size = 'sm' }) => {
  const { i18n } = useTranslation();

  const changeLanguage = (langCode) => {
    i18n.changeLanguage(langCode);
  };

  // Normaliser la langue pour extraire le code de base (ex: 'fr-FR' -> 'fr')
  const normalizeLang = (lang) => {
    if (!lang) return 'fr';
    const baseLang = lang.split('-')[0].toLowerCase();
    return baseLang === 'fr' || baseLang === 'en' ? baseLang : 'fr';
  };

  const currentLang = normalizeLang(i18n.language);
  
  const languages = {
    fr: { name: 'Français', flag: '🇫🇷' },
    en: { name: 'English', flag: '🇬🇧' }
  };

  // Sécurité : s'assurer que la langue existe dans l'objet languages
  const currentLangData = languages[currentLang] || languages.fr;

  return (
    <Dropdown align="end" className="language-selector-dropdown">
      <Dropdown.Toggle 
        variant={variant} 
        size={size}
        className="d-flex align-items-center gap-2 language-selector-toggle"
        style={{ fontSize: size === 'sm' ? '0.875rem' : '1rem' }}
      >
        <span>{currentLangData.flag}</span>
        <span className="d-none d-md-inline">{currentLangData.name}</span>
        <span className="d-inline d-md-none">{currentLang.toUpperCase()}</span>
      </Dropdown.Toggle>

      <Dropdown.Menu className="language-selector-menu">
        <Dropdown.Item 
          onClick={() => changeLanguage('fr')}
          active={currentLang === 'fr'}
          className="language-selector-item"
        >
          <span className="me-2">🇫🇷</span> Français
        </Dropdown.Item>
        <Dropdown.Item 
          onClick={() => changeLanguage('en')}
          active={currentLang === 'en'}
          className="language-selector-item"
        >
          <span className="me-2">🇬🇧</span> English
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default LanguageSelector;

